import { render, staticRenderFns } from "./Fulfillments.vue?vue&type=template&id=e9ce6b8c&scoped=true&"
import script from "./Fulfillments.vue?vue&type=script&lang=js&"
export * from "./Fulfillments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9ce6b8c",
  null
  
)

export default component.exports